export default "__VITE_ASSET__lCpRPA9M__"